import React from "react";
import { format } from "date-fns";
import { connect } from "react-redux";
import { getStoreName } from "../../utils/helpers/storeSetting";

const Footer = ({ storeSetting }) => {
  const storeName = getStoreName(storeSetting);

  return (
    <div className="page-wrapper">
      <footer className="footer footer-transparent d-print-none">
        <div className="container-xl">
          <div className="row text-center align-items-center flex-row">
            <div className="col-12 col-lg-auto mt-3 mt-lg-0">
              <ul className="list-inline list-inline-dots mb-0">
                <li className="list-inline-item">
                  Copyright &copy; {format(new Date(), "yyyy")}{" "}
                  <a href={storeSetting?.website || "/"} className="link-secondary">
                    {storeName}
                  </a>
                  . All rights reserved.
                </li>
                <li className="list-inline-item">
                  <a href="./changelog.html" className="link-secondary" rel="noopener">
                    {" "}
                    v1.1.0{" "}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  storeSetting: state?.stores?.setting,
});

export default connect(mapStateToProps)(Footer);
